import {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next'
import DashHeader from "../../../Component/sections/DashHeader/DashHeader";
import Table from "../../../Component/custom/Table/Table";
import "./PendingAppointments.css";
import Modal from "../../../Component/custom/Modal/Modal.jsx";
import TwoInputs from "../../../Component/common/TwoInputs/TwoInputs";
import {toast, ToastContainer} from "react-toastify";
import getData from "../../../utils/getData";
import axios from "axios";
import base_url from "../../../config/base_url";
import handleApiError from "../../../utils/handleApiError";
function PendingAppointments() {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const [addModal, setAddModal] = useState(false);
  const [appointment , setAppointment] = useState([])
  const [loader , setLoader] = useState(false)
  const [searchValue , setSearchValue] = useState("")


  const acceptAppointment = async(id) => {
    try{
      const res = await axios.put(`${base_url}/appointment/accept/${id}` , {},{
        headers:{
          Authorization: `Bearer ${token} `,
        }
      })
      getAppointments()
    }
    catch(error){
      handleApiError(error)
    }
    finally{
      // setLoader(true)
    }
  };
  const regectAppointment = async(id) => {
    try{
      const res = await axios.put(`${base_url}/appointment/reject/${id}` , {},{
        headers:{
          Authorization: `Bearer ${token} `,
        }
      })
      getAppointments()
    }
    catch(error){
      handleApiError(error)
    }
    finally{
      // setLoader(true)
    }
  };

  const AddPaitent = () => {
    setAddModal(false);
    toast.success(t('patientAdded'));
  };

  const getAppointments = async () => {
    setLoader(true)
    const res = await getData(`appointment?status=pending`)
    setAppointment(res?.data?.data)
    setLoader(false)
  };
  useEffect(() => {
    getAppointments();
  }, []);
  return (
    <div className='urgentReservations-container'>
      <div className='urgentReservations-content'>
        <ToastContainer />
        <DashHeader header={`${t('pendingAppointments')} (${appointment?.length || 0})`} getSearchValue = {(e)=>setSearchValue(e.target.value)}/>
        <Table
          searchValue={searchValue}
          headers={[
            t('userName'),
            t('phone'),
            t('date'),
            t('time'),
            t('status'),
            t('reason'),
            // "note",
            t('type'),
            t('price'),
            t('discount'),
            t('totalPrice'),
            t('gender'),
            t('actions'),
          ]}
          keys={["name", "phone", "date", "time","status" , "reason"]}
          data={appointment&& appointment}
          renderAction={(item) => (
            <>
              <td>{item.appointment_type.type}</td>
              <td>{item.appointment_type.price}</td>
              <td>{item.appointment_type.discount}</td>
              <td>{item.appointment_type.total_price}</td>
              <td>{item.gender}</td>
              <td className='btns'>
                <button
                  className='addBtn'
                  onClick={() => acceptAppointment(item.id)}
                >
                {t('accept')}
                </button>
                <button
                  className='cancelBtn'
                  onClick={() => regectAppointment(item.id)}
                >
                  {t('reject')}
                </button>
              </td>
            </>
          )}
          loader={loader}
        />
        <Modal
          isOpen={addModal}
          showModalsBtns={true}
          AcceptBtn={t('add')}
          handleAdd={AddPaitent}
          CancelBtn={t('cancel')}
          handleCancel={() => setAddModal(false)}
        >
          <h3>{t('addNewPatient')}</h3>
          <div className='inputs'>
            <TwoInputs
              typeOne={"text"}
              typeTwo={"number"}
              placeOne={t('enterName')}
              placeTwo={t('enterAge')}
            />
            <TwoInputs
              typeOne={"number"}
              typeTwo={"number"}
              placeOne={t('enterMobileNumber')}
              placeTwo={t('enterAge')}
            />
          </div>
        </Modal>
      </div>
    </div>
  );
}
export default PendingAppointments;
